import { http, HttpResponse } from "msw"
import type { ApiFinancialDataActivity } from "../../activity"
import { activityMock } from "./activity.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataActivityHandlers = [
  // ADH
  http.get(`${API_DOMAIN}/api/financial-data/adherent/activity`, () =>
    HttpResponse.json<ApiFinancialDataActivity>(activityMock()),
  ),
  // ADMIN
  http.get(`${API_DOMAIN}/api/financial-data/pharmacies/:pharmacyId/activity`, () =>
    HttpResponse.json<ApiFinancialDataActivity>(activityMock()),
  ),
  // ADVISOR
  http.get(
    `${API_DOMAIN}/api/financial-data/advisor/pharmacies/:pharmacyId/activity`,
    () => HttpResponse.json<ApiFinancialDataActivity>(activityMock()),
  ),
]
